var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a818181820a83753842bc7cd65261288eeb60fe3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hoyer-xp@harlapp-gmbh"]={id:"a818181820a83753842bc7cd65261288eeb60fe3"};
      